import { useMediaQuery } from "@material-ui/core";

export default function IsLargeScreen() {
	const largeScreen  = useMediaQuery("(min-width:900px)")
	return largeScreen;
}
